import styled from 'styled-components'

export const DataWrapper = styled.div`
  width: 100%;
  display: flex;
  color: ${(props): string => props.theme.colors.base.grey.grey1};
  margin: 0 20px 0 0;
`
